import './App.scss';
import React, { useEffect, lazy, Suspense } from 'react';

import { Switch, Route, BrowserRouter } from 'react-router-dom';
// import DashboardPage from './containers/DashboardPage/DashboardPage.jsx';

import DrawerRouterContainer from './components/DrawerRouterContainer/DrawerRouterContainer';
import { AppContext } from './context/AppContext';
import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';

import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import weekData from 'cldr-core/supplemental/weekData.json';

import frNumbers from 'cldr-numbers-full/main/fr/numbers.json';
import frLocalCurrency from 'cldr-numbers-full/main/fr/currencies.json';
import frCaGregorian from 'cldr-dates-full/main/fr/ca-gregorian.json';
import frDateFields from 'cldr-dates-full/main/fr/dateFields.json';

import usNumbers from 'cldr-numbers-full/main/en/numbers.json';
import usLocalCurrency from 'cldr-numbers-full/main/en/currencies.json';
import usCaGregorian from 'cldr-dates-full/main/en/ca-gregorian.json';
import usDateFields from 'cldr-dates-full/main/en/dateFields.json';

import esNumbers from 'cldr-numbers-full/main/es/numbers.json';
import esLocalCurrency from 'cldr-numbers-full/main/es/currencies.json';
import esCaGregorian from 'cldr-dates-full/main/es/ca-gregorian.json';
import esDateFields from 'cldr-dates-full/main/es/dateFields.json';

import { enMessages } from './messages/en-US';
import LoginPage from './containers/LoginPage/LoginPage';
const DataProvidersPage = lazy(() => import('./containers/DataProvidersPage/DataProvidersPage.jsx'));
const FlightSchedulesPage = lazy(() => import('./containers/FlightSchedulesPage/FlightSchedulesPage.jsx'));
const FlightsPage = lazy(() => import('./containers/FlightsPage/FlightsPage.jsx'));
const IntegrationMonitorPage = lazy(() => import('./containers/IntegrationMonitorPage/IntegrationMonitorPage.jsx'));
const SlotMessageMonitorPage = lazy(() => import('./containers/SlotMessageMonitorPage/SlotMessageMonitorPage.jsx'));
const SlotMessageSubmissionPage = lazy(() => import('./containers/SlotMessageSubmissionPage/SlotMessageSubmissionPage.jsx'));

load(
    likelySubtags,
    currencyData,
    weekData,
    frNumbers,
    frLocalCurrency,
    frCaGregorian,
    frDateFields,
    usNumbers,
    usLocalCurrency,
    usCaGregorian,
    usDateFields,
    esNumbers,
    esLocalCurrency,
    esCaGregorian,
    esDateFields
);

// loadMessages(esMessages, 'es');
// loadMessages(frMessages, 'fr');
loadMessages(enMessages, 'en-US');

const App = () => {
    const [contextState, setContextState] = React.useState({
        localeId: 'en-US',
        firstName: 'Peter',
        lastName: 'Douglas',
        middleName: '',
        email: 'peter.douglas@progress.com',
        phoneNumber: '(+1) 8373-837-93-02',
        avatar: null,
        country: 'USA',
        isInPublicDirectory: true,
        biography: '',
        teamId: 1
    });

    useEffect(() => {
        const ele = document.getElementById('ipl-progress-indicator')
        if (ele) {
            // fade out
            ele.classList.add('available')
            setTimeout(() => {
                // remove from DOM
                ele.outerHTML = ''
            }, 2000)
        }
    }, []);

    const onLanguageChange = React.useCallback(
        (event) => { setContextState({ ...contextState, localeId: event.value.localeId }) },
        [contextState, setContextState]
    );
    const onProfileChange = React.useCallback(
        (event) => {
            //console.log('Updating profile', contextState, event);
            setContextState({ ...contextState, ...event });
        },
        [contextState, setContextState]
    );

    return (
        <div className="App">
            <LocalizationProvider language={contextState.localeId}>
                <IntlProvider locale={contextState.localeId}>
                    <AppContext.Provider value={{ ...contextState, onLanguageChange, onProfileChange }}>
                        <BrowserRouter basename='/slot-management'>
                            <Switch>
                                <Route exact={true} path="/auth" component={LoginPage} />
                                <DrawerRouterContainer>
                                    <Suspense fallback={<div className="k-loading-mask">
                                        <span className="k-loading-text">Loading</span>
                                        <div className="k-loading-image"></div>
                                        <div className="k-loading-color"></div>
                                    </div>}>
                                        <Route exact={true} path="/" component={SlotMessageMonitorPage} />
                                        <Route exact={true} path="/slot-message-monitor" component={SlotMessageMonitorPage} />
                                        <Route exact={true} path="/dataProviders" component={DataProvidersPage} />
                                        <Route exact={true} path="/flight-schedules" component={FlightSchedulesPage} />
                                        <Route exact={true} path="/flights" component={FlightsPage} />
                                        <Route exact={true} path="/integration-monitor" component={IntegrationMonitorPage} />
                                        <Route exact={true} path="/slot-message-submission" component={SlotMessageSubmissionPage} />
                                        {/* <Route exact={true} path="/planning" component={Planning} />
                                    <Route exact={true} path="/profile" component={Profile} />
                                    <Route exact={true} path="/info" component={Info} /> */}

                                    </Suspense>
                                </DrawerRouterContainer>
                            </Switch>
                        </BrowserRouter>
                    </AppContext.Provider>
                </IntlProvider>
            </LocalizationProvider>
        </div>
    );
}

export default App;